"use client";

import { useState } from "react";
import Link from "next/link";

type FilterData = {
  [key: string]: { label: string; url: string, trackingClass?: string }[];
};

const TabClient = ({ filterData, inline = false, trackingClass }: { filterData: FilterData; inline?: boolean; trackingClass?:string; }) => {
  const tabs = Object.keys(filterData);
  const [activeTab, setActiveTab] = useState(tabs[0]);

  return (
    <>
      <div className="bg-white rounded-xl overflow-hidden shadow-[0_2px_10px_rgba(0,0,0,0.06)] border border-[#019a9926]">
        <div className="flex justify-between items-center gap-6 p-4 text-white bg-gradient-to-b from-[#008c8b] via-[#009a99] to-[#008c8b] max-[767px]:block">
          <div>
            <h2 className="m-0 text-lg font-semibold text-white">Find Your Perfect Car</h2>
            <p className="mt-1 mx-0 mb-3 text-[13px] opacity-90">
              Choose your preferred filter
            </p>
          </div>
          {/* Tabs */}
          <div
            className={`flex flex-wrap gap-2 bg-[#ffffff1a] rounded-lg p-1.5 max-[767px]:whitespace-nowrap max-[767px]:flex-nowrap max-[767px]:-mr-4 max-[767px]:overflow-x-auto max-[767px]:overflow-y-hidden ${
              inline ? "max-[767px]:inline-flex" : "max-[767px]:flex"
            }`}
          >
            {tabs.map((tab) => (
              <button
                key={tab}
                title={`${tab} Car`}
                className={`cursor-pointer border-none rounded px-4 py-2 text-[15px] font-bold leading-4 transition-all duration-300 ${trackingClass} ${
                  activeTab === tab ? "bg-white text-[#009688] font-semibold" : ""
                }`}
                onClick={() => setActiveTab(tab)}

              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        <div>
          {tabs.map((tab) => (
            <div
              key={tab}
              className={activeTab === tab ? "block" : "hidden"}
            >
              <div className="flex flex-wrap gap-2.5 p-4 whitespace-normal [&::-webkit-scrollbar]:hidden max-[767px]:whitespace-nowrap max-[767px]:block max-[767px]:overflow-x-auto">
                {filterData[tab]?.map((item) => (
                  <Link
                    prefetch={false}
                    key={item.url}
                    href={item.url}
                    title={`${item.label} Cars`}
                    className={`cursor-pointer text-[#364153] bg-gray-50 border border-[#e5e7eb] rounded-[7px] shrink-0 py-3 px-8.5 text-[13px] font-medium transition-all duration-300 hover:text-white hover:bg-[#009688] hover:border-[#009688] max-[767px]:mr-3 max-[767px]:last:mr-0 ${item?.trackingClass || ''}`}
                  >
                    {item.label}
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default TabClient;